<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m15.755 14.2549h-.79l-.28-.27c.98-1.14 1.57-2.62 1.57-4.23002 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5c0 3.59002 2.91 6.50002 6.5 6.50002 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99 1.49-1.49zm-6 0c-2.48999 0-4.5-2.01-4.5-4.50002 0-2.49 2.01001-4.5 4.5-4.5 2.49 0 4.5 2.01 4.5 4.5 0 2.49002-2.01 4.50002-4.5 4.50002z"
    />
  </svg>
</template>
